<template>
  <div>
    <Header />
    <HeaderResponsive />
    <div class="container">
      <SecondHeader />
      <p class="title_section">Imágenes - Galeria</p>
      <div class="row">
        <div class="col-md-7 col-sm-12">
          <Gallery :images="images" style="margin-left: -23px;"></Gallery>
        </div>
        <div class="col-md-4 col-sm-12">
          <carousel
            :per-page="1"
            :navigate-to="someLocalProperty"
            paginationActiveColor="#3366CC"
            id="carousel_noticias"
          >
            <slide v-for="(exp, index) in experiences" :key="index">
              <div class="row" style="margin-top: 30px;">
                <div class="col-md-6 col-sm-12">
                  <img
                    @click="changeImage(exp.filesTitle[0])"
                    :src="urlApi + '/container2s/images/download/' + exp.filesTitle[0]"
                    alt="imagen"
                    class="img-fluid carousel_image"
                  />
                </div>
                <div class="col-md-6 col-sm-12">
                  <img
                    @click="changeImage(exp.filesTitle[1])"
                    :src="urlApi + '/container2s/images/download/' + exp.filesTitle[1]"
                    alt="imagen"
                    class="img-fluid carousel_image"
                  />
                </div>
                <div class="col-md-6 col-sm-12">
                  <img
                    @click="changeImage(exp.filesTitle[2])"
                    :src="urlApi + '/container2s/images/download/' + exp.filesTitle[2]"
                    alt="imagen"
                    class="img-fluid carousel_image"
                  />
                </div>
              </div>
            </slide>
          </carousel>
        </div>
        <div class="col-md-1 col-sm-12">Anexos</div>
      </div>
    </div>
    <Footer />
  </div>
</template>


<script>
import Header from "./partials/Header";
import SecondHeader from "./partials/SecondHeader";
import HeaderResponsive from "./partials/HeaderResponsive";
import Footer from "./partials/Footer";
import Gallery from "vue-cover-gallery";
import { Carousel, Slide } from "vue-carousel";
import axios from "axios";
import config from '../../helpers/config'

export default {
  mounted() {
    this.getExperience(this.$route.params.id);
  },
  name: "Example",
  components: {
    Header,
    SecondHeader,
    HeaderResponsive,
    Footer,
    Gallery,
    Carousel,
    Slide
  },
  data() {
    return {
      urlApi: config.urlApi,
      experiences: [],
      images: [
        {
          title: "Agricultura",
          description: "Agricultura en Colombia",
          href:
            "http://blog.globalcaja.es/wp-content/uploads/2018/10/Agricultura-de-precision-1170x731.jpg"
        }
      ]
    };
  },
  methods: {
    changeImage(filename) {
      //console.log(filename);
      this.images[0].href = `${config.urlApi}/container2s/images/download/${filename}`;
      this.images.title = filename;
      this.images.description = filename;
    },
    getExperience(id) {
      axios
        .get(
          `${config.urlApi}/experiences?filter[where][id]=${id}&filter[where][expStatusId]=1`,
          {}
        )
        .then(response => {
          this.experiences = response.data;
        })
        .catch(function(error) {
          ////console.log(error)
        });
    }
  }
};
</script>


<style>
.carousel_image {
  margin-bottom: 10px !important;
}
</style>
